export const dummyPromise = () => new Promise((resolve) => {
  resolve()
})
